<mat-card class="balance-card default has-progress-bar profile-sidebar mb-6">
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span data-balance-card-title>{{ 'balance.card.title' | translate }}</span>
  </mat-card-title>
  <mat-card-content>
    <div *ngIf="loading" data-balance-card-loading class="balance-card__loading">
      {{ 'balance.card.loading' | translate }}
    </div>

    <div *ngIf="!loading && error" data-balance-card-error class="balance-card__error" role="alert">
      {{ error | translate }}
    </div>

    <div *ngIf="isEmpty" data-balance-card-empty class="balance-card__empty">
      {{ 'balance.card.empty' | translate }}
    </div>

    <div *ngIf="!loading && !error && hasBalances" class="balance-card__rows">
      <a
        *ngFor="let row of rows; trackBy: trackRow"
        data-balance-card-row
        class="balance-card__row"
        [attr.data-balance-id]="row.id"
        [routerLink]="row.href"
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <span fxFlex class="balance-card__row-id ellipsis">{{ row.id }}</span>
        <span class="balance-card__row-amount">{{ row.balance | balanceOutstanding | currency:'USD' }}</span>
      </a>
    </div>
  </mat-card-content>
  <mat-card-actions
    *ngIf="!loading && !error && hasBalances"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <span>{{ 'balance.card.unpaid-balance' | translate }}:</span>
    <strong data-balance-card-total class="text-warn">{{ outstandingTotal | currency:'USD' }}</strong>
  </mat-card-actions>
</mat-card>
